<div class="cellWrapper">
    @if (label) {
        {{ label }}
    } @else {
        {{ defaultValueIfNull ?? '' | translate }}
    }
</div>
